import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {BaseHttpService} from '../base.service';
import {SessionService} from '../session.service';

import {FinishEcvModel} from '../../../finish-ecv/finish-ecv.model';
import 'rxjs/add/observable/of';

@Injectable()
export class EndStatisticsService extends BaseHttpService {

  private static endStatisticsPath = 'api/ecv/end_statistics/';
  private static finishProcessingEcvPath = EndStatisticsService.endStatisticsPath + 'finish_processing';

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  getEndStatistics(userId: number): Observable<any> {
    return this.httpGet(EndStatisticsService.endStatisticsPath + userId);
  }

  finishProcessingEcv(model: FinishEcvModel): Observable<any> {
    return this.httpPost(EndStatisticsService.finishProcessingEcvPath, model).map(
      response => {
        Object.assign(model, response);
      })
      .catch((err) => Observable.of(true));
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/end-statistics.service.ts